import React from "react";
import {
  //   GeoLocateUser,
  InRouteDash,
  TitleBar,
} from "webapp/components";
import NewWebAppMapClass from "webapp/components/WebAppMap/WebAppMap";
import { useTranslation } from "react-i18next";
import TrxNowGoogleMap from "webapp/components/TrxNowMap/TrxNowGoogleMap";
import { devLog } from "utils/devLog";

export default function ProviderEnroute(props) {
  const { t } = useTranslation();
  const LocateUserObj = {
    img: props.logo,
    partner: props.currState.partner,
    fragment: (
      <React.Fragment>
        <p className="mb-0">
          <strong>{t("description.ProviderEnrouteTitleBar1")}</strong>
          <br />
          <span style={{ color: "#999" }}>{t("description.ProviderEnrouteTitleBar2")}</span>
        </p>
      </React.Fragment>
    ),
  };

  return (
    <React.Fragment>
      {/* <NewWebAppMapClass height={"400px"} mapCreated={mapCreated} destinationCoords={props.destCoords} disablementCoords={props.startingCoords}/> */}
      {devLog("props.startingCoords:", props.startingCoords)}
      {devLog("props.destCoords:", props.destCoords)}
      <TrxNowGoogleMap
        disablementCoords={props.startingCoords}
        destinationCoords={props.destCoords}
        zoom={14}
        width={"100%"}
        height={400}
        enRouteToService={props.enRouteDest}
        markersDraggable={false}
      />
      <TitleBar data={LocateUserObj} />
      <InRouteDash data={props.data} cancelFunc={props.cancelFunc} helpFunc={props.helpFunc} />
    </React.Fragment>
  );
}
